import { SafePlugin } from '@atlaskit/editor-common/safe-plugin';
import type { PMPluginFactoryParams } from '@atlaskit/editor-common/types';

import { createInitialState, createPluginState } from './prompt-action-plugin-factory';
import { aiExperiencePromptActionPluginKey } from './prompt-action-plugin-key';

export const createPromptActionPlugin = (options: {
	dispatch: PMPluginFactoryParams['dispatch'];
}): SafePlugin => {
	const { dispatch } = options;

	return new SafePlugin({
		key: aiExperiencePromptActionPluginKey,
		state: createPluginState(dispatch, createInitialState()),
	});
};
